// Vendor
import { createAction, props } from '@ngrx/store';
export const setAdvancedOptions = createAction('[Custom PDF Report Builder] Set Advanced Options', props());
